import { useState } from "react";
import { EyeIcon, PencilSquareIcon, TrashIcon } from "@heroicons/react/24/outline";
import AddUserModal from './AddUserModal';
import { useNavigate } from "react-router-dom";
import { students } from "./UserManagementData";
import UserManageEducator from "../pages/Management/UserManageEducator";
import UserMangenetStudent from "../pages/Management/UserMangenetStudent";
import DeleteModal from "./DeleteModal";
import { userService } from "../services/userService";
import toast from "react-hot-toast";
import helpers from "../utils/helpers";
const roleColors = {
  Student: "bg-green-100 text-green-600",
  Admin: "bg-red-100 text-red-600",
  Educator: "bg-orange-100 text-orange-600",
  Family: "bg-blue-100 text-blue-600", // Added Family role with a blue scheme
};

export default function UserTable({ users, handleAddUser, permission }) {
  const [accountStatus, setAccountStatus] = useState({});
  const [selected, setSelected] = useState([]); // track selected rows
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);
  const [isDeleteOpen, setIsDeleteOpen] = useState(false);
  const [deleteAppId, setDeleteAppId] = useState({})

  const handleAccountToggle = (id, current) => {
    setAccountStatus((prev) => ({
      ...prev,
      [id]: current === "Activate" ? "Deactivate" : "Activate",
    }));
  };


  const handleEditUser = (user) => {
    setSelectedUser(user);   // pass user object to prefill form
    setIsEditModalOpen(true);
  };



  const allSelected = selected.length === users.length;

  const toggleSelectAll = () => {
    if (allSelected) {
      setSelected([]);
    } else {
      setSelected(users.map((u) => u.id));
    }
  };

  const toggleSelect = (id) => {
    setSelected((prev) =>
      prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id]
    );
  };

  const handleDelete = async () => {
    try {

      console.log(deleteAppId, 'deleteAppId')
      let data = { id: deleteAppId?.user_id }

      const response = await userService.deleteUser(data)
      if (response?.success == true) {
        await getAllApplicationList()
        setDeleteAppId({})
        toast.success(response?.message || 'user deleted successfully')
        setIsDeleteOpen(false);
      } else {
        toast.error(response?.message)
      }
    } catch (e) {

    }
  };
  const navigate = useNavigate();

  // View handler
  const handleView = (role, user_id) => {
    const cryptId = helpers.encryptId(user_id)
    navigate(`/userProfile/${cryptId}`); // 👈 This should match your route
    // navigate(`/userProfile/${user_id}`);

  };


  return (
    <div className="">
      {/* Header */}
      <div className="flex justify-between items-center mb-4">
        <div className="flex items-center gap-2">
          <label className="text-sm text-gray-600">Show</label>
          <select className="border rounded px-2 py-1 text-sm">
            <option>24</option>
            <option>48</option>
          </select>
        </div>

        {/* Delete icon appears only when some rows are selected */}
        {permission?.deleteMultipal === true && selected.length > 0 && (
          <TrashIcon
            className="h-6 w-6 text-red-600 cursor-pointer hover:text-red-800"
            onClick={handleDelete}
          />
        )}
      </div>

      {/* Table */}
      <div className="overflow-hidden border border-gray-100 rounded-xl">
        <table className="w-full text-left text-sm">
          <thead className=" text-gray-600">
            <tr>
              <th className="py-3 px-3">
                <input
                  type="checkbox"
                  checked={allSelected}
                  onChange={toggleSelectAll}
                  className="w-5 h-5"
                />
              </th>
              <th className="py-4 px-3">NAME</th>
              <th className="py-4 px-3">ROLE</th>
              <th className="py-4 px-3">EMAIL</th>
              <th className="py-4 px-3">LAST LOGIN</th>
              <th className="py-4 px-3">APP. COUNT</th>
              <th className="py-4 px-3">STATUS</th>
              <th className="py-4 px-3">ACCOUNT</th>
              {(permission?.view === true || permission?.edit === true || permission?.deleteSingle === true) &&
                <th className="py-4 px-3">ACTION</th>
              }
            </tr>
          </thead>
          <tbody>
            {users.map((user, index) => {
              const account =
                accountStatus[user.user_id] ||
                (user.status === "Active" ? "Activate" : "Deactivate");
              const isChecked = selected.includes(user.user_id);

              return (
                <tr
                  key={user.user_id}
                  className={`border-t shadow-sm hover:shadow-lg transition duration-200 ${index % 2 === 0 ? "bg-white" : "bg-gray-50"
                    }`}
                >
                  <td className="py-4 px-3">
                    <input
                      type="checkbox"
                      checked={isChecked}
                      onChange={() => toggleSelect(user.user_id)}
                      className="w-5 h-5"
                    />
                  </td>
                  <td className="py-4 px-3">
                    <div>
                      <p className="font-medium">{user.full_name}</p>
                      <p className="text-xs text-gray-500">ID: {user.user_id}</p>
                    </div>
                  </td>
                  <td className="py-4 px-3">
                    <span
                      className={`px-3 py-1 rounded-md text-xs font-medium ${roleColors[user.role_name]}`}
                    >
                      {user.role_name}
                    </span>
                  </td>
                  <td className="py-4 px-3">{user.email}</td>
                  <td className="py-4 px-3">{user.last_login}</td>
                  <td className="py-4 px-3">{user.app_count}</td>
                  <td className="py-4 px-3">
                    {user.status === "Active" ? (
                      <span className="flex items-center gap-1 text-green-600 text-sm ">
                        <input type="checkbox" checked className="w-5 h-5" /> Active
                      </span>
                    ) : (
                      <span className="flex items-center gap-1 text-gray-500 text-sm">
                        <input type="checkbox" className="w-5 h-5" r /> Inactive
                      </span>
                    )}
                  </td>
                  <td className="py-4 px-3">
                    <div className="flex items-center gap-2">
                      <span
                        className={`w-3 h-3 rounded-full ${account === "Activate" ? "bg-green-500" : "bg-gray-400"
                          }`}
                      ></span>
                      <select
                        value={account}
                        onChange={() => handleAccountToggle(user.user_id, account)}
                        className="border rounded px-2 py-2 text-sm  focus:outline-none focus:ring-0 focus-visible:ring-0"
                      >
                        <option>Activate</option>
                        <option>Deactivate</option>
                      </select>
                    </div>
                  </td>
                  <td className="py-3 px-3 flex gap-2 text-gray-500">
                    {permission?.view === true &&
                      <EyeIcon onClick={() => handleView(user.role_name, user.user_id)} className="h-5 w-5 cursor-pointer hover:text-blue-500" />
                    }
                    {permission?.edit === true &&
                      <PencilSquareIcon onClick={() =>
                        handleEditUser({
                          id: user.user_id,
                          fullName: user.full_name,
                          email: user.email,
                          phone: user.phone_number,
                          roles: user.role_name,
                          role: user.role_id.toString(),
                          school: user.school,
                          grade: user.grade_id,
                          section: user.section_id,
                          sendWelcome: true,
                        })
                      } className="h-5 w-5 cursor-pointer hover:text-green-500" />
                    }
                    {permission?.deleteSingle === true &&
                      <TrashIcon
                        className="w-5 h-5 cursor-pointer text-red-600 hover:font-800"
                        onClick={() => { setIsDeleteOpen(true); setDeleteAppId(user) }}
                      />
                    }
                    {/* <TrashIcon onClick={handleDelete} className="h-5 w-5 cursor-pointer hover:text-red-500" /> */}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>

      {/* Footer */}
      <div className="flex justify-between items-center mt-4 text-sm text-gray-600">
        <p>1 - 10 of 13 Pages</p>
        <div className="flex gap-2">
          <button className="border rounded p-1">&lt;</button>
          <button className="border rounded p-1">&gt;</button>
        </div>
      </div>

      <DeleteModal
        isOpen={isDeleteOpen}
        onClose={() => { setIsDeleteOpen(false); setDeleteAppId({}) }}
        onConfirm={handleDelete}
      />


      <AddUserModal
        isOpen={isEditModalOpen}
        onClose={() => setIsEditModalOpen(false)}
        onSave={(values) => {
          console.log("User Updated ✅", values);
          setIsEditModalOpen(false);
          handleAddUser(values); // ✅ call the passed handleAddUser function
        }}
        user={selectedUser}   // 👈 pass user details here to prefill
      />










    </div>
  );
}
